import { cn } from '@noor/lib/cn';
import { FiltersRoot, type FiltersRootProps } from './filters-root';

export type FiltersBarProps = FiltersRootProps;

/**
 * `Filters.Bar` — `Filters.Root` with the standard toolbar chrome baked in: a
 * bottom-bordered, muted bar that stacks its controls on mobile and spreads
 * them across a row (first control left, rest right) from `sm` up.
 *
 * The plain `Filters.Root` leaves all layout to the caller; the toolbars that
 * sit at the top of a full-height table/grid page share this exact chrome, so
 * `Bar` is the preset for them — a page-level toolbar composes it and adds only
 * its own controls. Pass `className` to extend (it merges after the preset).
 */
export function FiltersBar({ className, ...props }: FiltersBarProps) {
  return (
    <FiltersRoot
      {...props}
      className={cn(
        'flex-col items-stretch gap-3 border-b border-border bg-muted px-4 py-3 sm:flex-row sm:flex-nowrap sm:items-center sm:justify-between sm:px-6',
        className,
      )}
    />
  );
}
